(function($) {

    $(document).on("keyup","#search-input", function (e) {
        $searchValue = $(this).val();

        if (e.keyCode === 13) {
            window.location.replace(window.location.origin + "?s=" + $searchValue)
        }
    });

    if($('section.search-results').length ) {
        let count = $("#results-count").text();
        $(".resultCount").text(count);
    }


    var $searchOverlay = document.querySelector(".search-overlay");
    var $search = document.querySelector("#search-trigger");
    var $clone, offsetX, offsetY;

    $("a[href='#search-trigger']").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        $("#search-trigger").trigger('click');

        // let rect = $(this).getBoundingClientRect();
        // offsetX = rect.left;
        // offsetY = rect.top;

    });

        $search.addEventListener("click", function() {
            var $original = this;
            $clone = this.cloneNode(true);

            $searchOverlay.classList.add("s--active");

            $clone.classList.add("s--cloned", "s--hidden");
            $searchOverlay.appendChild($clone);

            var triggerLayout = $searchOverlay.offsetTop;

            var originalRect = $original.getBoundingClientRect();
            var cloneRect = $clone.getBoundingClientRect();

            offsetX = originalRect.left / 1.5;
            offsetY = originalRect.top / 1.5;

            // console.table({
            //     'Original Rect': originalRect,
            //     'Offset X': offsetX,
            //     'Offset Y': offsetY,
            // });

            // $clone.style.transform = "translate("+ offsetX +"px, "+ offsetY +"px)";
            $original.classList.add("s--hidden");
            $clone.classList.remove("s--hidden");

            var triggerLayout = $searchOverlay.offsetTop;

            $clone.classList.add("s--moving");

            $clone.setAttribute("style", "");
            openAfterMove();


            // $clone.addEventListener("transitionend", openAfterMove);
        });

        function openAfterMove() {
            $clone.classList.add("s--active");
            $clone.querySelector("input").focus();

            addCloseHandler($clone);
            $clone.removeEventListener("transitionend", openAfterMove);
        };

        function addCloseHandler($parent) {
            var $closeBtn = $parent.querySelector(".search__close");
            $closeBtn.addEventListener("click", closeHandler);
        };

        /* close handler functions */
        function closeHandler(e) {
            $clone.classList.remove("s--active");
            e.stopPropagation();

            var $cloneBg = $clone.querySelector(".search__bg");

            $cloneBg.addEventListener("transitionend", moveAfterClose);
        };

        function moveAfterClose(e) {
            e.stopPropagation(); // prevents from double transitionend even fire on parent $clone

            // $clone.classList.add("s--moving");
            // $clone.style.transform = "translate("+ offsetX +"px, "+ offsetY +"px)";
            // $clone.addEventListener("transitionend", terminateSearch);
            terminateSearch()
        };

        function terminateSearch(e) {
            $search.classList.remove("s--hidden");
            $clone.remove();
            $searchOverlay.classList.remove("s--active");
        };



})( jQuery );